import React, { useEffect, useState } from 'react';
import { Grid, Typography, TextField, Button, Select, MenuItem, CircularProgress } from '@mui/material'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import appConfig from "../../config/appConfig";
import * as menuActions from '../../store/actions/breadcrumb';
import '../../style/common.css';
import * as Styled from '../../components/styled-components/Styled-Components';
import DeleteIcon from '@mui/icons-material/Delete';
import { useForm, Controller } from 'react-hook-form';
import * as businessUnitActions from '../../store/actions/businessUnit';
import countryLisJson from '../../config/countryList';
import { useLogout } from '../../components/Utils';
import { useTranslation } from 'react-i18next';

const ErrorStyle = {
    color: "red",
    display: 'flex',
    marginTop: '5px'
}
const textboxCss = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};


const CreateBusinessUnit = ({setBreadcrumb, createNewBusinessUnit, businessUnitData, createdbusinessUnitData, getAllCountriesAndCurrency, countriesList}) => {
    const { t } = useTranslation('common');
    const params = useLocation();
    const navigate = useNavigate();
    const [currenyMenuItem, setCurrenyMenuItem] = useState('cad');
    const [locationList, setLocationList] = useState([{id: `test-${new Date().getTime()}`, locationName: "", locationAddress: "", country: "", currency: ""}]);
    const [apiErr, setApiErr] = useState('');
    const { register, handleSubmit, formState: { errors }, clearErrors, control, setValue } = useForm();
    const [locationError, setLocationError] = useState({locationNameErr: '', locationAddressErr: '',countryErr: '',currencyErr: '',})
    const [isLoading, setIsLoading] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const onLogout = useLogout();

    const handleChange = (e) => {
        setCurrenyMenuItem(e.target.value);
      };

    useEffect(() => {
        const subMenuData = {
            name: t("Business Units & Locations"),
            route: "/business-units",
            subRoutes: "create-businessunit",
            subRoutesLabel: t("Create"),
            isSubMenu: true
        }

        setBreadcrumb(subMenuData);
        getAllCountriesAndCurrency();
      }, [t]);
      useEffect(() => {
        if(countriesList && countriesList?.status === 200){
            setCountryList(countriesList?.data)
        } else if(countriesList && countriesList?.status === 401){ 
            onLogout();
        }
      }, [countriesList]);

      const onChangeInput = (e, property, id, index) => {
        setLocationList((prevLocationList) => {
          const updatedLocationList = prevLocationList.map((location, currentIndex) => {
            if (currentIndex === index) {
              const newValue = e.target.value;
              location[property] = newValue;
              clearErrors(`${property}[${id}]`);
              setLocationError({})
            }
            return location;
          });
          return updatedLocationList;
        });
      };
      
      
    const handleAddClick = () => {
        setLocationError({})
        // const newRow = { id: `test-${new Date().getTime()}`, locationName: "", locationAddress: "", currency: ""};
        const newRow = { id: `test-${new Date().getTime()}`, locationName: "", locationAddress: "", country: "", currency: ""};
        setLocationList(prevData => [...prevData, newRow]);
    };

    const handleFormSubmit = (data) => {
        if(!Object?.keys(errors)?.length){
            sendFormValues(data);
        }
    }
    const sendFormValues = (formData) => {
          const associatedLocations = locationList?.map((location, index) => ({
            locationName: location.locationName?.trim(),
            address: location.locationAddress ? location.locationAddress?.trim() : location.address?.trim(),
            countryId: location.country || countryLisJson?.data[0].id,
            id: null ,
            currency: location.currency || "cad"
          }));
        
        const data = {
            businessUnitName: formData.businessName?.trim(),
            businessLocation: associatedLocations
        }
        if(locationList && locationList.length === 0) {
            setLocationError({
                // locationAddressErr: 'Please enter address.',
                locationAddressErr:"",
                locationNameErr: t('Please enter location'),
                countryErr: t('Please enter country'),
                currencyErr: t('Please enter currency'),
            })
            setLocationList([{ id: `test-${new Date().getTime()}`, locationName: "", locationAddress: "", country: "", currency: ""}])
        } else {
            setIsLoading(true);
            setLocationError({})
            createNewBusinessUnit(data)
        }
    }
    
    const handleRemoveClick = (idToRemove) => {
      if(typeof idToRemove !== "number") {
        setLocationList(prevData => prevData.filter(row => row?.id !== idToRemove));
      } else {
        setLocationList(prevData => prevData.filter(row => row?.id !== idToRemove));
      }
    };

    useEffect(() => {
        if(createdbusinessUnitData && createdbusinessUnitData.status === 200) {
            setIsLoading(false);
            navigate('/business-units');
        }
        else if (createdbusinessUnitData && createdbusinessUnitData.status === 403){
            setIsLoading(false);
            setApiErr(createdbusinessUnitData.message)
        }
        else if (createdbusinessUnitData && createdbusinessUnitData.status === 401){
            setIsLoading(false);
            onLogout();
        }
    }, [createdbusinessUnitData]);

 
    const setCurrencyFunction = (data,property, id, index) => {
        const newObject = {
            target: {
                value : data?.currency
            }
        }
        onChangeInput(newObject, property, id, index)
    }
    return <div>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} xl={8} lg={8} md={12}>
                    <h1 style={{ margin: 0, fontSize: "21px" }}><b>{t("Business Units & Locations")}</b></h1>
                </Grid>
            </Grid>
            <hr className='blue-border' style={{marginBottom: 35}}/>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                <Grid container spacing={2}>

                    <Grid item md={12} xl={8} lg={8} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Business Unit Name")} <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('businessName', { required: true,validate: value => value.trim() !== '' ||t('Please enter business unit name') , pattern: /^[A-Za-z0-9 ]+$/})}
                                margin="normal"
                                id="businessName"
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "Business name" }}
                            />
                        </div>
                        {(errors?.businessName?.type === "required" || errors?.businessName?.type === "validate") && <span style={ErrorStyle}>{t('Please enter business unit name')}</span>}
                        {errors?.businessName?.type === "pattern" && (<span style={ErrorStyle}>{t('Special characters not allowed')}</span>)}
                        {apiErr !== '' && (<span style={ErrorStyle}>{apiErr}</span>)}
                    </Grid>
                    <Grid item md={12} xl={8} lg={8} sm={12} xs={12}>
                        <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-bold'>{t("Associated Locations")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                    </Grid>
                    
                    <Grid container spacing={2} style={{width: '100%'}}>
                    <Grid item md={12} xl={8} lg={8} sm={12} xs={12}>
                    {locationList.length !== 0 ? 
                    <Grid item container spacing={2} className="pl-0 m-0">
                          <Grid item xs={3} md={2}>
                            <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t("Location")} </Typography>
                          </Grid>
                          <Grid item xs={9} md={5}>
                           <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t("Address")}</Typography>
                          </Grid>
                          <Grid item xs={5} md={2}>
                           <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t("Country")}</Typography>
                          </Grid>
                          <Grid item xs={5} md={2}>
                            <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t("Currency")}</Typography>
                          </Grid>
                          <Grid item xs={2} md={1} style={{display: 'flex', gap: 10, justifyContent: 'end', padding: 0}}>
                          </Grid>
                        </Grid> : ''}
                    {locationList?.map((obj,index) => (
                        <Grid item container spacing={2} className="pl-0 m-0" key={obj.id}>
                          <Grid item xs={3} md={2}>
                          <TextField
                                {...register(`locationName[${obj.id}]`, { required: true, validate: value => value.trim() !== '' || t("Please enter location")})}                                
                                margin="normal"
                                id={`locationName[${obj.id}]`}
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                onChange={(e) => onChangeInput(e, 'locationName', obj?.id, index)} 
                                inputProps={{ "aria-label": "location" }}
                            />
                            {(errors?.locationName?.[obj.id]?.type === "required" || errors?.locationName?.[obj.id]?.type === "validate") && <span style={ErrorStyle}>{t("Please enter location")}</span>}
                            {locationError?.locationNameErr !== "" && <span style={ErrorStyle}>{locationError?.locationNameErr}</span>}
                         </Grid>
                          <Grid item xs={9} md={5}>
                          <TextField
                                {...register(`locationAddress[${obj.id}]`, { required: false})}                                
                                margin="normal"
                                id={`locationAddress[${obj.id}]`}
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                onChange={(e) => onChangeInput(e, 'locationAddress', obj?.id, index)} 
                                inputProps={{ "aria-label": "address" }}
                            />
                            {locationError?.locationAddressErr !== "" && <span style={ErrorStyle}>{locationError?.locationAddressErr}</span>}
                            {errors?.locationAddress?.[obj.id]?.type === "required" && <span style={ErrorStyle}>{t("Please enter address")}</span>}
                          </Grid>
                          <Grid item xs={5} md={2}>
                          <Controller
                            name={`country[${obj.id}]`}
                            control={control}
                            defaultValue={obj.country}
                            rules={{ required: t('Please select country') }}
                            render={({ field }) => (
                                <>
                                <Select
                                    {...field}
                                    className='normal-dropdown xxs-normal'
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    MenuProps={{
                                        style: { maxHeight: '300px' } // Set the desired max height here
                                    }}
                                    onChange={(e) => {
                                    onChangeInput(e, 'country', obj.id, index);
                                    field.onChange(e);
                                    // Clear the error when the selection changes
                                    clearErrors(`country[${obj.id}]`);
                                    }}
                                >
                                    {countryList?.map((item, i) => (
                                    <MenuItem key={item} className='xxs-normal filter-item' value={item.id} onClick={()=>{setCurrencyFunction(item,'currency', obj.id, index)}}>
                                        {item.countryName}
                                    </MenuItem>
                                    ))}
                                </Select>
                                </>
                            )}
                            />

                            {locationError?.countryErr !== "" && <span style={ErrorStyle}>{locationError?.countryErr}</span>}
                            {errors?.country?.[obj.id]?.type === "required" && (
                                <span style={ErrorStyle}>{t("Please select country")}</span>
                            )}

                          </Grid>
                          <Grid item xs={5} md={2}>
                          <Controller
                            name={`currency[${obj.id}]`}
                            control={control}
                            defaultValue={obj.currency}
                            rules={{required: false}}
                            // rules={{ required: 'Please select currency.' }}
                            render={({ field }) => (
                                <>
                                <Select
                                    {...field}
                                    className='normal-dropdown xxs-normal'
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    value={obj.currency}
                                    disabled
                                    sx={{textTransform: 'uppercase'}}
                                    onChange={(e) => {
                                    field.onChange(e);
                                    onChangeInput(e, 'currency', obj.id, index);
                                    clearErrors(`currency[${obj.id}]`);
                                    }}
                                >
                                    {countryList?.map((item, i) => (
                                    <MenuItem key={i} className='xxs-normal filter-item' value={item.currency} style={{textTransform:'uppercase'}} >
                                        {item.currency}
                                    </MenuItem>
                                    ))}
                                </Select>
                                </>
                            )}
                            />
                            {/* {locationError?.currencyErr !== "" && <span style={ErrorStyle}>{locationError?.currencyErr}</span>} */}
                            {/* {errors?.currency?.[obj.id]?.type === "required" && <span style={ErrorStyle}>Please select currency.</span>} */}

                          </Grid>
                          <Grid item xs={2} md={1} style={{display: 'flex', gap: 10, justifyContent: 'end'}}>
                                <div onClick={() => handleRemoveClick(obj.id)} className='action-icon'>
                                    <DeleteIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.darkblue}} />
                                </div>
                          </Grid>
                        </Grid>
                        ))}
                        <Button variant="outlined" style={{marginLeft: 16}} onClick={handleAddClick} className="add-field-btn">
                            {t("Add Location")}
                        </Button>   
                    </Grid>
                   
                </Grid>
                </Grid>
                <Grid container spacing={2}>
                <Grid item xs={12} sm={6} xl={4} lg={4} md={6}>
                    <Styled.PrimaryButton
                            type='submit'
                            variant="contained"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            disabled={isLoading}
                            // onClick={() => handleFormSubmit()}
                        >
                             {isLoading ? (<><CircularProgress className='progress-color' /><span style={{color:'#fff'}}>{t("Saving...")}</span></>) : <span>{t("Save")}</span>}
                        </Styled.PrimaryButton>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4} lg={4} md={6}>
                        <Styled.CancelButton
                            variant="outlined"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            onClick={() => navigate('/business-units')}
                        >
                            {t("Cancel")}
                        </Styled.CancelButton>
                    </Grid>
                    
                </Grid>
            </form>
    </div >
}

CreateBusinessUnit.propTypes = {
    businessUnitData: PropTypes.arrayOf(PropTypes.array).isRequired,
    clearCampaignValues: PropTypes.func.isRequired,
    createNewBusinessUnit: PropTypes.func.isRequired,
    getAllCountriesAndCurrency: PropTypes.func.isRequired,
    setBreadcrumb: PropTypes.func.isRequired
}


const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.setSubmenu(menu)),
        createNewBusinessUnit: (data) => dispatch(businessUnitActions.createNewBusinessUnit(data)),
        getAllCountriesAndCurrency: (data) => dispatch(businessUnitActions.getAllCountriesAndCurrency(data))
    };
}
const mapStateToProps = (state) => ({ 
    businessUnitData: state.businessUnit,
    createdbusinessUnitData: state.businessUnit.createbusinessUnitData,
    countriesList: state.businessUnit.countriesList
 })


export default connect(mapStateToProps, mapDispatchToProps)(CreateBusinessUnit);